import React from "react";
import { Classes } from "@blueprintjs/core";
import classNames from "classnames";
var intentToClass = {
  danger: Classes.INTENT_DANGER,
  warning: Classes.INTENT_WARNING,
  success: Classes.INTENT_SUCCESS,
  primary: Classes.INTENT_PRIMARY
};
export default function IntentText(_ref) {
  var intent = _ref.intent,
      text = _ref.text,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(Classes.FORM_GROUP, intentToClass[intent])
  }, /*#__PURE__*/React.createElement("div", {
    className: Classes.FORM_HELPER_TEXT
  }, text || children));
}